import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
// import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import NavDropdown from "react-bootstrap/NavDropdown";
import Logo from "../../../assets/image/logo.png";
import banner from "../../../assets/image/jjs-banner.jpg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoginRedirection from "../../Service/LoginRedirection";
import TokenUndefined from "../../Service/TokenUndefined";
import "../../../assets/CustomNavbar.css"; // Import your custom styles
import { message } from "antd";
function ExhibitorDashboardNavbar() {
  const [showOwner, setShowOwner] = useState(false);
  const [showScan, setShowScan] = useState(false);
  const [scanStatus, setScanStatus] = useState(false);
  const [showStaff, setShowStaff] = useState(false);
  const [showVIPGuest, setshowVIPGuest] = useState(false);
  const [showSetting, setshowSetting] = useState(false);
  const [exhibitorName, setExhibitorName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showFamily, setShowFamily] = useState(false);
  const [canAddBuyer, setCanAddBuyer] = useState(false);
  const [showExtraOwnerModal, setShowExtraOwnerModal] = useState(false);

  const navigate = useNavigate();

  const showOwnerDropdown = (e) => {
    setShowOwner(!showOwner);
  };
  const hideOwnerDropdown = (e) => {
    setShowOwner(false);
  };

  const showScanDropdown = (e) => {
    setShowScan(!showScan);
  };
  const hideScanDropdown = (e) => {
    setShowScan(false);
  };

  const showStaffDropdown = (e) => {
    setShowStaff(!showStaff);
  };
  const hideStaffDropdown = (e) => {
    setShowStaff(false);
  };

  const showModalDropdown = (e) => {
    setShowModal(!showModal);
  };
  const hideModalDropdown = (e) => {
    setShowModal(false);
  };

  const showFamilyDropdown = (e) => {
    setShowFamily(!showModal);
  };
  const hideFamilyDropdown = (e) => {
    setShowFamily(false);
  };

  const showVIPGuestDropdown = (e) => {
    setshowVIPGuest(!showVIPGuest);
  };
  const hideVIPGuestDropdown = (e) => {
    setshowVIPGuest(false);
  };
  const showSettingDropdown = (e) => {
    setshowSetting(!showSetting);
  };
  const hideSettingDropdown = (e) => {
    setshowSetting(false);
  };
  const exhibitorAgentType = localStorage.getItem("exhibitor_agent_type");

  const handleLogout = (e) => {
    localStorage.removeItem("jff_token");
    localStorage.removeItem("category");
    localStorage.removeItem("permission");
    localStorage.removeItem("exhibitor_agent_type");

    navigate(`/${exhibitorAgentType.toLowerCase()}/login`);
  };

  useEffect(() => {
    TokenUndefined(`${exhibitorAgentType.toLowerCase()}/login`);
    axios
      .post(`${process.env.REACT_APP_API_END_POINT}/get-exhibitor-name`, "", {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        // LoginRedirection(res, "exhibitor/login");
        setExhibitorName(res.data.data);
        setCanAddBuyer(res.data.can_add_buyer);
      })
      .catch((err) => {
        // LoginRedirection("/superadmin/login");
        if (err.response.status === 401) {
          navigate(`/${exhibitorAgentType.toLowerCase()}/login`);
          localStorage.removeItem("jff_token");
          localStorage.removeItem("category");
          localStorage.removeItem("permission");
          localStorage.removeItem("user_id");
          localStorage.removeItem("type_of_user");
        }
      });
  }, []);

  const handleAddOwnerClick = () => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`, {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        console.log(res.data);

        if (res.data.ownerstatus) {
          navigate(
            `/${exhibitorAgentType.toLowerCase()}/${exhibitorAgentType.toLowerCase()}-owner-registration`
          );
        } else {
          message.error("The limit to add new members has exhausted");
        }
      });
  };
  const handleAddStaffClick = () => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`, {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        if (res.data.staffstatus) {
          navigate(
            `/${exhibitorAgentType.toLowerCase()}/${exhibitorAgentType.toLowerCase()}-staff-registration`
          );
        } else {
          setShowExtraOwnerModal(true);
        }
      });
  };
  const handleAddModalClick = () => {
    navigate(
      `/${exhibitorAgentType.toLowerCase()}/${exhibitorAgentType.toLowerCase()}-modal-registration`
    );
  };

  const handleAddFamilyClick = () => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`, {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        console.log(res.data);

        if (res.data.familyStatus) {
          navigate(
            `/${exhibitorAgentType.toLowerCase()}/${exhibitorAgentType.toLowerCase()}-family-registration`
          );
        } else {
          message.error("Limit Exhaust");
        }
      });
  };

  const handleAddViprClick = () => {
    navigate(
      `/${exhibitorAgentType.toLowerCase()}/${exhibitorAgentType.toLowerCase()}-vip-registration`
    );
    // axios
    //   .get(`${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`, {
    //     headers: {
    //       token: localStorage.getItem("jff_token"),
    //     },
    //   })
    //   .then((res) => {
    //     console.log(res.data);
    //     if (res.data.vipstatus) {
    //       navigate(
    //         `/${exhibitorAgentType.toLowerCase()}/${exhibitorAgentType.toLowerCase()}-vip-registration`
    //       );
    //     } else {
    //       message.error("The limit to add new members has exhausted");
    //     }
    //   });
  };

  useEffect(() => {
    const getRegistrationVisibility = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`,
        {
          headers: {
            token: localStorage.getItem("jff_token"),
          },
        }
      );

      setScanStatus(res.data.data.exhibitor_scan === "active");
    };

    getRegistrationVisibility();
  }, []);

  return (
    <>
      <div className="text-center">
        <img
          src={banner}
          alt="Placeholder"
          className="img-fluid vh-50 w-100 top-img mb-4"
        />
      </div>
      <div className="d-flex">
        {" "}
        <div className="d-flex mx-auto align-items-center">
          <span className="fw-bold fs-1">{exhibitorName}</span>
        </div>
        {/* <div className="align-items-center d-flex">
          <h5 className="text-danger">
            Facing Problem Please Call:-{" "}
            <a
              className="text-danger text-decoration-none"
              href="tel: +91-7737450029"
            >
              +91-7737450029
            </a>{" "}
          </h5>
        </div> */}
      </div>
      <Navbar className="custom-navbar" expand="lg">
        <img
          src={Logo}
          alt="logo-img"
          className="my-1 mx-5"
          style={{ height: "30px", width: "60px" }}
          onClick={() =>
            navigate(`/${exhibitorAgentType.toLowerCase()}/dashboard`)
          }
        />
        <Container>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="me-auto my-2 my-lg-0" navbarScroll>
              {" "}
              <Nav.Link
                onClick={() =>
                  navigate(`/${exhibitorAgentType.toLowerCase()}/dashboard`)
                }
              >
                Dashboard
              </Nav.Link>
              {/* <NavDropdown
                title="Owner"
                id="collasible-nav-dropdown"
                show={showOwner}
                onMouseEnter={showOwnerDropdown}
                onMouseLeave={hideOwnerDropdown}
              >
                {" "}
                <NavDropdown.Item onClick={() => handleAddOwnerClick()}>
                  Add Owner
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={() =>
                    navigate(`/${exhibitorAgentType.toLowerCase()}/owner-list`)
                  }
                >
                  Owner List
                </NavDropdown.Item>
              </NavDropdown> */}
              {/* <NavDropdown
                title="Staff"
                id="collasible-nav-dropdown"
                show={showStaff}
                onMouseEnter={showStaffDropdown}
                onMouseLeave={hideStaffDropdown}
              >
                {" "}
                <NavDropdown.Item onClick={() => handleAddStaffClick()}>
                  Add Staff
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={() =>
                    navigate(`/${exhibitorAgentType.toLowerCase()}/staff-list`)
                  }
                >
                  Staff List
                </NavDropdown.Item>
              </NavDropdown> */}
              {/* <NavDropdown
                title="Model"
                id="collasible-nav-dropdown"
                show={showModal}
                onMouseEnter={showModalDropdown}
                onMouseLeave={hideModalDropdown}
              >
                {" "}
                <NavDropdown.Item onClick={() => handleAddModalClick()}>
                  Add Model
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={() => navigate("/exhibitor/modal-list")}
                >
                  Model List
                </NavDropdown.Item>
              </NavDropdown> */}
              {/* <NavDropdown
                title="Family"
                id="collasible-nav-dropdown"
                show={showFamily}
                onMouseEnter={showFamilyDropdown}
                onMouseLeave={hideFamilyDropdown}
              >
                {" "}
                <NavDropdown.Item onClick={() => handleAddFamilyClick()}>
                  Add Family
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={() => navigate("/exhibitor/family-list")}
                >
                  Family List
                </NavDropdown.Item>
              </NavDropdown> */}
              {exhibitorAgentType.toLowerCase() === "exhibitor" &&
                canAddBuyer && (
                  <>
                    <NavDropdown
                      title="Buyer"
                      id="collasible-nav-dropdown"
                      show={showVIPGuest}
                      onMouseEnter={showVIPGuestDropdown}
                      onMouseLeave={hideVIPGuestDropdown}
                    >
                      <NavDropdown.Item onClick={() => handleAddViprClick()}>
                        Add Buyer
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item
                        onClick={() =>
                          navigate(
                            `/${exhibitorAgentType.toLowerCase()}/vip-guest-requrest-list`
                          )
                        }
                      >
                        Buyer Request List
                      </NavDropdown.Item>

                      <NavDropdown.Divider />
                      <NavDropdown.Item
                        onClick={() =>
                          navigate(
                            `/${exhibitorAgentType.toLowerCase()}/vip-guest-list`
                          )
                        }
                      >
                        Buyer Approved List
                      </NavDropdown.Item>
                    </NavDropdown>
                  </>
                )}
              {scanStatus && (
                <NavDropdown
                  title="Scan"
                  id="collasible-nav-dropdown"
                  show={showScan}
                  onMouseEnter={showScanDropdown}
                  onMouseLeave={hideScanDropdown}
                >
                  <NavDropdown.Item
                    onClick={() => {
                      navigate(`/exhibitor/exhibitor-scan`);
                    }}
                  >
                    Start Scanning
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={() => navigate(`/exhibitor/scan-list`)}
                  >
                    Scanned List
                  </NavDropdown.Item>
                </NavDropdown>
              )}
              <NavDropdown
                title="Setting"
                id="collasible-nav-dropdown"
                show={showSetting}
                onMouseEnter={showSettingDropdown}
                onMouseLeave={hideSettingDropdown}
              >
                <NavDropdown.Item
                  onClick={() =>
                    navigate(
                      `/${exhibitorAgentType.toLowerCase()}/change-password`
                    )
                  }
                >
                  Change Password
                </NavDropdown.Item>

                <NavDropdown.Divider />

                <NavDropdown.Item onClick={() => handleLogout()}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Modal
        show={showExtraOwnerModal}
        onHide={() => setShowExtraOwnerModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Limit Exceeded</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            If you want to add more members, You need to Pay Rs 1180/- per
            Member
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            onClick={() => {
              setShowExtraOwnerModal(false);
              navigate(
                `/${exhibitorAgentType.toLowerCase()}/${exhibitorAgentType.toLowerCase()}-staff-registration`
              );
            }}
          >
            Add Member
          </Button>
          <Button
            variant="outline-primary"
            onClick={() => setShowExtraOwnerModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ExhibitorDashboardNavbar;
